import {
	REQUEST_REVIEW_LIST,
	REQUEST_REVIEW_LIST_FOR_CAMPAIGN
} from './mutation-types';

import axiosInst from "@/utility/axiosInst";

export default {
	requestReviewListForCampaign({commit}, payload) {
		const {currentPage, campaignSeq, sortType} = payload
		return axiosInst.springAxiosInst.get("review/campaign-review-list", {
			params: {
				page: currentPage,
				campaignSeq: campaignSeq,
				sortType: sortType
			}
		}).then((res) => {
			commit(REQUEST_REVIEW_LIST_FOR_CAMPAIGN, res.data);
		})
	},

	requestCreateReview({}, payload) {
		return axiosInst.springAxiosInst.post("review/create-review", payload)
			.then((res) => {
				return res.data
			})
	},

	requestReviewListByBetween({commit}, payload) {
		const {currentPage, startDate, endDate} = payload
		return axiosInst.springAxiosInst.get("/review/get-between-list", {
			params: {
				page: currentPage,
				startDate: startDate,
				endDate: endDate
			}
		}).then((res) => {
			commit(REQUEST_REVIEW_LIST, res.data);
		})
	}
}